import { setCookie } from 'cookies-next'
import dayjs from 'dayjs'

export const GsuIndiaWebsiteUrl = 'https://getsetup.in'

export const UserCountryPrefernceCookieName = 'gsu-user-country-preference'
export enum UserCountryPrefernceCookieValues {
  'UNKNOWN' = 'UNKNOWN',
  'INDIA' = 'INDIA',
  'GLOBAL' = 'GLOBAL',
}

export function setCountryPreferenceGlobal(): void {
  setCookie(UserCountryPrefernceCookieName, UserCountryPrefernceCookieValues.GLOBAL, {
    expires: dayjs().add(365, 'days').toDate(),
    path: '/',
    sameSite: true,
  })
}

export function setCountryPreferenceIndiaAndRedirect(): void {
  setCookie(UserCountryPrefernceCookieName, UserCountryPrefernceCookieValues.INDIA, {
    expires: dayjs().add(365, 'days').toDate(),
    path: '/',
    sameSite: true,
  })
  window.location.href = GsuIndiaWebsiteUrl
}
